<div class="rs-hint">
  <div class="rs-hint__content">{{content}}</div>
</div>
